import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import MinusIcon from '../icons/Minus';
import Logo from './Logo';
import Loading from './Loading';
import useTrainer from '../hooks/useTrainer';

const sections = ({ trainerSlug, links }) => {
  let columns = [
    {
      title: 'General',
      links: [
        {
          title: 'About',
          url: `/${trainerSlug}/about`,
        },
        {
          title: 'Contact Us',
          url: `/${trainerSlug}/contact`,
        },
        {
          title: 'Privacy Policy',
          url: `/${trainerSlug}/privacy_policy`,
        },
        {
          title: 'Terms of Service',
          url: `/${trainerSlug}/terms_of_service`,
        },
      ],
    },
    {
      title: 'Account',
      links: [
        {
          title: 'Forgot Password?',
          url: `/${trainerSlug}/forgot_password`,
        },
        {
          title: 'My Account',
          url: `/${trainerSlug}/account`,
        },
        //        TODO, finish this page
        //        {
        //          title: 'My Activities',
        //          url: `${trainerSlug}/activties`,
        //        },
      ],
    },
  ];

  if (links?.length > 0) {
    columns.push({ title: 'Social', links });
  }
  return columns;
};

const Footer = (props) => {
  const { data, error, loading: dataLoading } = useTrainer();
  if (!data) {
    return <Loading />;
  }
  if (dataLoading) {
    return <Loading />;
  }
  if (error) {
    console.error(error);
    return <></>;
  }
  const { appleAppStoreLink, googlePlayStoreLink, links } =
    data?.webPage?.footerSection;

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        pb: 6,
        pt: {
          md: 15,
          xs: 6,
        },
      }}
      {...props}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid
            item
            md={3}
            sm={4}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              order: {
                md: 1,
                xs: 4,
              },
            }}
            xs={12}
          >
            <Link href={`/${data?.webPage?.slug}`}>
              <Logo />
            </Link>
            <Typography color="textSecondary" sx={{ mt: 1 }} variant="caption">
              {(appleAppStoreLink || googlePlayStoreLink) &&
                'Get the workouts on your phone:'}
              {appleAppStoreLink && (
                <p>
                  <Link href={appleAppStoreLink}>
                    <img
                      alt="apple apple store"
                      src="https://d272s49zbiop50.cloudfront.net/ccfit/apple-download.png"
                      width={150}
                    />
                  </Link>
                </p>
              )}

              {googlePlayStoreLink && (
                <p>
                  <Link href={googlePlayStoreLink}>
                    <img
                      alt="google play"
                      src="https://d272s49zbiop50.cloudfront.net/ccfit/google-play.png"
                      width={150}
                    />
                  </Link>
                </p>
              )}
            </Typography>
          </Grid>
          {sections({
            trainerSlug: data?.webPage?.slug,
            links,
          }).map((section, index) => (
            <Grid
              item
              key={section.title}
              md={3}
              sm={4}
              sx={{
                order: {
                  md: index + 2,
                  xs: index + 1,
                },
              }}
              xs={12}
            >
              <Typography color="textSecondary" variant="overline">
                {section.title}
              </Typography>
              <List disablePadding>
                {section.links.map((link) => (
                  <ListItem
                    disableGutters
                    key={link.title}
                    sx={{
                      pb: 0,
                      pt: 1,
                    }}
                  >
                    <ListItemAvatar
                      sx={{
                        alignItems: 'center',
                        display: 'flex',
                        minWidth: 0,
                        mr: 0.5,
                      }}
                    >
                      <MinusIcon color="primary" />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Link
                          href={link.url}
                          color="textPrimary"
                          variant="subtitle2"
                        >
                          {link.title}
                        </Link>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          ))}
        </Grid>
        <Divider
          sx={{
            borderColor: (theme) =>
              alpha(theme.palette.primary.contrastText, 0.12),
            my: 6,
          }}
        />
        <Typography color="textSecondary" variant="caption">
          {props.trainerName
            ? `© 2021 ${props.trainerName}.`
            : `All Rights Reserved.`}{' '}
          <br />
          Created with{' '}
          <Link href="https://www.tempokit.com" target="_blank">
            Tempokit
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
